"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
exports.default = (function (stretch) {
    var _a = tslib_1.__read(React.useState({ width: 0, height: 0 }), 2), targetSize = _a[0], setTargetSize = _a[1];
    function measureStretch(element) {
        setTargetSize({
            width: element.offsetWidth,
            height: element.offsetHeight,
        });
    }
    // Merge stretch style
    var style = React.useMemo(function () {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height;
            // Stretch with target
            if (stretch.indexOf('height') !== -1 && height) {
                sizeStyle.height = height;
            }
            else if (stretch.indexOf('minHeight') !== -1 && height) {
                sizeStyle.minHeight = height;
            }
            if (stretch.indexOf('width') !== -1 && width) {
                sizeStyle.width = width;
            }
            else if (stretch.indexOf('minWidth') !== -1 && width) {
                sizeStyle.minWidth = width;
            }
        }
        return sizeStyle;
    }, [stretch, targetSize]);
    return [style, measureStretch];
});
//# sourceMappingURL=useStretchStyle.js.map